@if (ready) {
  <div class="row" style="height: 330px;">
    <div class="col-1 px-0 py-2" style="max-height: 330px;">
      <div class="custom-y-axis-labels">
        @for (data of series.slice().reverse(); track data) {
          <div class="label text-start" style="padding: 16px 0px;">
            <i class="ri-{{ data.value ? 'checkbox-circle-line text-success' : 'close-circle-line text-danger' }}"></i>
            {{ data.name }}
          </div>
        }
      </div>
    </div>
    <div class="col-11 p-0" style="max-height: 330px;">
      @if (ready) {
        <ngx-charts-heat-map class="dark" style="max-height: 330px;"
          [scheme]="colorScheme"
          [legend]="legend"
          [tooltipText]="tooltipText"
          [animations]="animations"
          [showXAxisLabel]="showXAxisLabel"
          [showYAxisLabel]="showYAxisLabel"
          [min]="min"
          [max]="max"
          [xAxis]="xAxis"
          [yAxis]="yAxis"
          [results]="chartData">
        </ngx-charts-heat-map>
      }
    </div>
  </div>
}
@if (!ready) {
  <div class="d-flex justify-content-center align-items-center" style="height: 330px;">
    <app-loading-spinner></app-loading-spinner>
  </div>
}